import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReferralReportsItem } from '@modules/reports/models/referral-reports-item';
import { ApiService } from '@shared/services';

@Injectable()
export class ReferralReportsService extends ApiService<ReferralReportsItem> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'referrals/reports/';
  }
}
